import { render, staticRenderFns } from "./install.vue?vue&type=template&id=3518cbeb&scoped=true"
import script from "./install.vue?vue&type=script&lang=ts"
export * from "./install.vue?vue&type=script&lang=ts"
import style0 from "./install.vue?vue&type=style&index=0&id=3518cbeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3518cbeb",
  null
  
)

export default component.exports